var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 14 15",
    fill: "#9BA1A0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03581 12.7646C5.47448 12.7154 3.98972 12.6771 2.50495 12.6197C2.18503 12.606 1.85964 12.5568 1.54792 12.483C0.962764 12.3462 0.558076 11.9935 0.350263 11.4166C0.183467 10.9517 0.12331 10.4732 0.0795604 9.98647C-0.0161428 8.8435 -0.0161428 7.70054 0.0303416 6.55757C0.0576854 5.91226 0.0740916 5.26147 0.246357 4.6353C0.350263 4.26069 0.476045 3.89429 0.77956 3.62358C1.09948 3.33647 1.47409 3.16421 1.90065 3.14507C3.07097 3.08765 4.23854 3.01655 5.40886 3.00561C6.98386 2.98921 8.56159 3.01108 10.1366 3.04116C10.8175 3.05483 11.5038 3.09038 12.1792 3.17788C12.7971 3.25991 13.2592 3.60444 13.5053 4.20601C13.694 4.66811 13.7651 5.1521 13.8061 5.64429C13.9128 6.87749 13.9155 8.11069 13.8553 9.34389C13.8253 9.97007 13.7952 10.599 13.6175 11.2087C13.4151 11.9087 12.9858 12.3708 12.2694 12.5294C11.9905 12.5896 11.7007 12.6115 11.4163 12.6224C9.92878 12.6744 8.44401 12.7208 7.03581 12.7646ZM5.5237 9.65561C6.77058 9.0103 8.00378 8.37046 9.26159 7.71694C8.00651 7.06069 6.77331 6.41811 5.5237 5.7646C5.5237 7.0689 5.5237 8.35132 5.5237 9.65561Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4798dc43461f2e7a3143ed4b13934803.svg";
export { ForwardRef as ReactComponent };